export default "__VITE_ASSET__BOxqNrrw__"